/**
 * @flow
 */
'use strict';

export const occupationCodes = [
    {"code":"School"},
    {"code":"Driver"},
    {"code":"Engineer"},
    {"code":"Laborer"},
    {"code":"Computer programmer"},
    {"code":"Technician"},
    {"code":"Data input"},
    {"code":"Secretary"},
    {"code":"Student"}
]

export const hobbyCodes = [
    {"code":"Needlework"},
    {"code":"Painting"},
    {"code":"Drawing"},
    {"code":"Exercise"},
    {"code":"Reading"},
    {"code":"Sports"}
]

export const computerUseCodes = [
    {"code":"Occasional use"},
    {"code":"<1 hours"},
    {"code":"1-2 hours"},
    {"code":"2-5 hours"},
    {"code":"5-8 hours"},
    {"code":"over 8 hours"},
    {"code":"Separate computer glasses used"}
]
